import React, { useEffect } from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import { useTranslation } from '@/hooks/useTranslation';

// Importiere alle Sektionen
import HeaderSection from './HeaderSection';
import FeaturesSection from './FeaturesSection';
import DetailsSection from './DetailsSection';
import AgencyComparisonSection from './AgencyComparisonSection';
import AssessmentSection from './AssessmentSection';
import BenefitsSection from './BenefitsSection';
import CallToActionSection from './CallToActionSection';
import CtoServiceContactSection from './ContactSection';

// Registriere die Übersetzungen
import translations from './translations';
import { registerTranslations } from '@/hooks/useTranslation';

// Registriere die Übersetzungen für diese Seite
registerTranslations('ctoServicePage', translations);

const CtoServicePage = () => {
  const { t } = useTranslation();
  
  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo 
        title={t('ctoServicePage.header.title')}
        description={t('ctoServicePage.header.description')}
        canonical="/cto-service"
      />
      <Layout>
        <main>
          <HeaderSection />
          <FeaturesSection />
          <DetailsSection />
          <AgencyComparisonSection />
          <AssessmentSection />
          <BenefitsSection />
          <CallToActionSection />
          <CtoServiceContactSection />
        </main>
      </Layout>
    </>
  );
};

export default CtoServicePage; 